import AXIOS from "./axios";

export class Auth {
  static login({ email, password }) {
    return AXIOS.post("/auth/sign_in", { email, password });
  }

  static register(payload) {
    payload.cpf = payload.cpf.replace(/[^0-9.]/g, "");
    payload.phone_number = payload.phone_number.replace(/[^0-9.]/g, "");

    return AXIOS.post("/auth", { user: payload });
  }

  static logout() {
    return AXIOS.delete("/auth/sign_out");
  }

  static forgotPassword(payload) {
    payload.redirect_url =
      process.env.VUE_APP_FORGOT_PASSWORD_REDIRECT_URL || "";
    return AXIOS.post("/auth/password", { ...payload });
  }

  static updatePassword({ password, password_confirmation, headers }) {
    return AXIOS.put(
      "/auth/password",
      { password, password_confirmation },
      { headers: { ...headers } }
    );
  }
}
